import { useMutation } from '@tanstack/react-query';

import { refreshAllPropertyContentCache } from '~/services/AccommodationService';

interface UseRefreshPropertyContentCacheParams {
  propertyId: string;
}

export function useRefreshPropertyContentCache() {
  return useMutation({
    mutationFn: async ({ propertyId }: UseRefreshPropertyContentCacheParams) => {
      const response = await refreshAllPropertyContentCache({ propertyId });
      return response.result;
    },
  });
}
